import { Button, Popover, PopoverContent, PopoverTrigger } from "@izicvs/ui";
import { t } from "@lingui/macro";
import { Bell } from "@phosphor-icons/react";
import { useNavigate } from "react-router";

import { useAlerts, useAlertsCount, useMarkAlertsRead } from "@/client/services/jobs";

export const NotificationsBell = () => {
  const navigate = useNavigate();
  const { count } = useAlertsCount();
  const { alerts } = useAlerts();
  const { markRead } = useMarkAlertsRead();

  const onOpenChange = (open: boolean) => {
    if (open && count > 0) void markRead();
  };

  return (
    <Popover onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button size="icon" variant="ghost" className="relative">
          <Bell size={20} />
          {count > 0 && (
            <span className="absolute -right-0.5 -top-0.5 flex size-4 items-center justify-center rounded-full bg-error text-[10px] font-bold text-white">
              {count > 9 ? "9+" : count}
            </span>
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent align="start" className="w-80 p-0">
        <div className="border-b p-3">
          <p className="text-sm font-semibold">{t`New offers`}</p>
          <p className="text-xs opacity-60">{t`From your followed searches.`}</p>
        </div>

        {alerts && alerts.length > 0 ? (
          <div className="max-h-80 overflow-y-auto">
            {alerts.map((alert) => (
              <button
                key={alert.id}
                type="button"
                className="block w-full border-b p-3 text-left transition-colors last:border-b-0 hover:bg-secondary-accent/20"
                onClick={() => navigate("/dashboard/opportunities")}
              >
                <p className="line-clamp-1 text-sm font-medium">{alert.job.title}</p>
                <p className="line-clamp-1 text-xs opacity-60">
                  {[alert.job.company, alert.profile.keywords].filter(Boolean).join(" · ")}
                </p>
              </button>
            ))}
          </div>
        ) : (
          <p className="p-4 text-sm opacity-60">{t`No new offers.`}</p>
        )}
      </PopoverContent>
    </Popover>
  );
};
